import { connect } from 'react-redux';
import AutoAllocateIndicator from '../../../components/DailyPlanning/AutoAllocate/AutoAllocateIndicator';
import { refreshScheduler, autoAllocate, autoUnallocate } from '../../../actions/areas/dailyPlanning';

const mapStateToProps = ({ areas: { dailyPlanning } }) => {
  const {
    autoAllocate: { isAllocating },
  } = dailyPlanning;
  return {
    isAllocating,
  };
};

const mapDispatchToProps = dispatch => ({
  autoAllocate: queryData => dispatch(autoAllocate(queryData)),
  autoUnallocate: queryData => dispatch(autoUnallocate(queryData)),
  refreshScheduler: () => dispatch(refreshScheduler()),
});

const AutoAllocateIndicatorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AutoAllocateIndicator);

export default AutoAllocateIndicatorContainer;
